// React
import React, { ReactElement } from 'react';
// Interface
import { SearchFilterProps } from '@utmb/types/start-list-table';
// Styles
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import debounce from 'lodash.debounce';

const SearchFilter = (props: SearchFilterProps): ReactElement => {
    const { currentSearch, setCurrentSearch } = props;

    const { t } = useTranslation();

    const handleInputChange = (element: any) => {
        setCurrentSearch(element.target.value);
    };

    const handleKeyPress = (e: any) => {
        if (e.code === 'Enter') {
            setCurrentSearch(e.target.value);
        }
    };

    return (
        <div className={styles.toolbar_search}>
            <input
                className={styles.searchInput}
                onInput={debounce(handleInputChange, 500)}
                type="search"
                placeholder={t('qualifier.filters.search')}
                defaultValue={currentSearch}
                onKeyPress={handleKeyPress}
            />
        </div>
    );
};

export default SearchFilter;
